<template>
    <div class="pl20 pr20">
        <span class="dib">基础信息</span>
        <div class="mt20">
            <el-form :model="supplier" :rules="rules" ref="supplier" label-width="207px" class="demo-ruleForm">
                <el-form-item label="供应商id:"><span>{{ supplier.supplierId }}</span></el-form-item>
                <el-form-item label="供应商编号:"><span>{{ supplier.supplierCode }}</span></el-form-item>
                <el-form-item label="供应商名称:"><span>{{ supplier.supplierName }}</span></el-form-item>
                <el-form-item label="对接采销:" prop="managerUserId">
                    <el-select class="ml_10 vtb" v-model="supplier.managerUserId" filterable placeholder="请选择对接采销">
                        <el-option v-for="val in managerUserList" :label="val.name" :value="val.id" :key="val.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属部门:" prop="categoryDeptId">
                    <el-select class="ml_10 vtb" v-model="supplier.categoryDeptId" placeholder="请选择所属部门">
                        <el-option v-for="val in deptList" :label="val.name" :value="val.id" :key="val.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div align="center" class="mb20">
                <el-button class="mr10" type="primary" @click="cancel()">取消</el-button>
                <el-button type="primary" @click="submit()">保存</el-button>
            </div>
        </div>
    </div>

</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                supplier: {
                    supplierId:'',
                    supplierCode:'',
                    supplierName:'',
                    managerUserId:'',
                    categoryDeptId:''
                },
                managerUserList:[],
                deptList:[],
                rules: {}
            }
        },
        methods: {
            fetch () {
                this.getDeptList();
                this.getManagerUserList();
                this.getSupplierDetail();
            },

            getSupplierDetail () {
                var _this = this;
                $.ajax({
                    url: '/suppliers/supplier/detail?suppliersId=' + _this.supplier.supplierId,
                    type: 'GET',
                    success: function (result) {
                        if (!result.code && result.data) {
                            _this.supplier.supplierId = result.data.suppliersId;
                            _this.supplier.supplierCode = result.data.suppliersCode;
                            _this.supplier.supplierName = result.data.suppliersName;
                            _this.supplier.managerUserId = result.data.managerUserId;
                            _this.supplier.categoryDeptId = result.data.categoryDeptId;
                        }
                    }
                })
            },

            getDeptList () {
                var _this = this;
                $.ajax({
                    url: '/suppliers/supplierCommon/depts/find',
                    type: 'GET',
                    success: function (result) {
                        if (!result.code && result.data) {
                            _this.deptList = result.data.list;
                        }
                    }
                })
            },

            getManagerUserList () {
                var _this = this;
                $.ajax({
                    url: '/suppliers/supplierCommon/managers/find',
                    type: 'GET',
                    success: function (result) {
                        if (!result.code && result.data) {
                            _this.managerUserList = result.data.list;
                        }
                    }
                })
            },

            // 取消
            cancel () {
                this.$confirm('取消后系统将不保存您输入的信息。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    window.close();
                }).catch(() => {
                    console.log("取消")
                });
            },

            // 提交
            submit() {
                var _this = this;
                var msg = '保存供应商信息';
                if(!_this.supplier.supplierId){
                    _this.$message.error('供应商id不能为空!');
                    return;
                }
                if(!_this.supplier.managerUserId){
                    _this.$message.error('对接采销不能为空!');
                    return;
                }
                if(!_this.supplier.categoryDeptId){
                    _this.$message.error('请选择所属部门!');
                    return;
                }

                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var that = this;
                    var data = {};
                    data.suppliersId = _this.supplier.supplierId;
                    data.suppliersCode = _this.supplier.supplierCode;
                    data.suppliersName = _this.supplier.supplierName;
                    data.managerUserId = _this.supplier.managerUserId;
                    data.categoryDeptId = _this.supplier.categoryDeptId;
                    $.ajax({
                        url: '/suppliers/supplier/update',
                        data: JSON.stringify(data),
                        dataType: "json",
                        contentType: 'application/json;charset=utf-8',
                        type: 'POST',
                        success: function (result) {
                            if (result.code == 0) {
                                _this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                window.close();
                            } else {
                                _this.$message({
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消保存'
                    });
                });
            },

        },
        watch: {

        },
        mounted () {
            this.$nextTick(function () {
                var supplierId = this.$route.query.suppliersId;
                this.supplier.supplierId = supplierId;
                this.fetch();

            })
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
        display: inline-block;
        margin-left: 3%;
        width: 91%;
        height: 1px;
        border-bottom: 1px dashed #999;
        vertical-align: middle;
    }

    .second_line {
        display: inline-block;
        margin-left: 3%;
        width: 87%;
        height: 1px;
        border-bottom: 1px dashed #666;
        vertical-align: middle;
    }

    .word_num {
        display: inline-block;
        margin-bottom: 22px;
        margin-left: 5px;
        color: #666;
        vertical-align: bottom;
    }

    .pic_tip {
        position: absolute;
        top: 100%;
        left: 0;
        padding-top: 4px;
        color: #ff4949;
        font-size: 12px;
        line-height: 1px;
    }
    .edit_wrap {
        margin: 50px auto;
        width: 1050px;
        border: 1px solid #eee;
        .edit_tab {
            display: inline-block;
            width: 262px;
            height: 46px;
            background: #ff6c83;
            color: #fff;
            text-align: center;
            line-height: 46px;
        }
        .active_tab {
            background: #ff4a7d;
        }
        .tip_word {
            margin-top: 20px;
            padding: 10px;
            width: 1048px;
            height: 160px;
            background: #f9f9f9;
        }
    }
    .fixeds {
        position: absolute;
        top: 37px;
        right: 69px;
        z-index: 2;
        width: 148px;
        height: 148px;
        background: #fff;
    }
    .pic_min_skan {
        box-sizing: border-box;
        margin-top: 5px;
        width: 60px;
        height: 60px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        cursor: pointer;
    }
    .rule_star {
        position: relative;
        left:-76px;
    }
    .rule_star2 {
        position: relative;
        left:-120px;
    }
    .rule_star3 {
        position: relative;
        left:-190px;
    }
    .rule_star4 {
        position: relative;
        left:-132px;
    }
    .rule_star5 {
        position: relative;
        left:-160px;
    }
    .rule_star6 {
        position: relative;
        left:-150px;
    }
    .rule_star200 {
        position: relative;
        left:-200px;
    }
    .rule_star105 {
        position: relative;
        left:-105px;
    }
    .ml_10 {
        margin-left: -10px;
    }
    .lh20 {
        line-height: 20px;
    }
</style>


// WEBPACK FOOTER //
// supplier_info_edit.vue?4988074e